export const ORDER_DETAILS_SIDEBAR_NAMESPACE = 'order-details-sidebar';
